var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEarlyCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_91_3521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6666 11.3862V11.9996C15.6658 13.4372 15.2003 14.836 14.3395 15.9875C13.4788 17.1389 12.2688 17.9812 10.8902 18.3888C9.5116 18.7965 8.03815 18.7475 6.68963 18.2493C5.3411 17.7511 4.18975 16.8303 3.40729 15.6243C2.62482 14.4183 2.25317 12.9916 2.34776 11.5571C2.44235 10.1226 2.99812 8.75712 3.93217 7.66428C4.86621 6.57145 6.1285 5.80982 7.53077 5.493C8.93304 5.17618 10.4002 5.32113 11.7133 5.90624",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6667 6.66624L9 13.3396L7 11.3396",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_91_3521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(1 3.99957)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarlyCheck);
export default __webpack_public_path__ + "static/media/early-check.d28864bdb493d9a3b723fbbea4112244.svg";
export { ForwardRef as ReactComponent };